import type { FaireProductEntity } from "../../entity_types/product";

export const p_gqr3tvjgu3: FaireProductEntity = {
  token: "p_gqr3tvjgu3",
  type: "product",
  name: "Essentials: Wild Rose + Ginger Candle  | 12 oz.",
  brandToken: "b_b19tidse3g",
  brandName: "BOTANICA",
  imageUrl:
    "https://cdn.faire.com/fastly/08bab2bf899347bdb9cfec7c84791bd6fe87dde6e95c7450db941135e088b818.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e9feb1673232031cba89ff257c2d77bab64685c280cdc1fa54918e2adf4aff93.jpeg",
    "https://cdn.faire.com/fastly/82a61d97d0d93659b81699d547d88730a57337fb17b92b8923d195c7288daa4e.jpeg",
    "https://cdn.faire.com/fastly/68f34fb29afa32debfd5ea2a70c55ffe2ef828959bb79740165b3bf01e06b200.jpeg",
    "https://cdn.faire.com/fastly/21bdae58f3f10e40bf85b46708d4ad3e5db2395021513dedc4a61b7b90f08ff7.jpeg",
    "https://cdn.faire.com/fastly/7436ceb4e7acdba4b7ac65bef31ab2abf283736a73622dc4f576eec491a3ed5e.jpeg",
  ],
  priceDollars: 22,
  description:
    "A rose by any other name indeed. This floral fragrance uses true, fresh rose oils–not powdery in the least–and pairs them with a slightly spicy ginger to create a distinctive floral blend that isn't too on-the-nose. (pun intended?) The Botanica Essentials Candle Collection features pure essential oils, balanced with nuanced fragrance oils to create provocative and true-to-nature scents. \n\nFragrance Notes: Wild Rose, Ginger, Petrichor\n\n• SOY & COCONUT WAX CANDLE | 100% COTTON WICK \n• 12 oz. | 70+ HOUR BURN TIME",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:42.973Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
